// extracted by mini-css-extract-plugin
module.exports = {"main-page":"HowTo_main-page__2B7T3"};